import { QueryCache, QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 60, //in milliseconds - 1 hr
            gcTime: 1000 * 60 * 60, //in milliseconds - 1 hr
            refetchOnWindowFocus: false,
        },
    },
});

const queryCache = new QueryCache();

export { queryClient, queryCache };
